import useCartStore from "../../utils/cartStore";
import { useState } from "react";

const EventProductCard = ({ product }) => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [quantity, setQuantity] = useState(1);

  const handleAddToCart = () => {
    addToCart(
      {
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        category: "Événements",
        description: product.description || ""
      },
      quantity
    );
  };

  return (
    <div className="bg-white rounded-2xl shadow p-6">

      <img
        src={product.image || "/images/placeholder.jpg"}
        alt={product.name}
        className="w-full h-56 object-contain rounded-xl mb-4"
      />

      <h2 className="text-xl font-semibold mb-2">
        {product.name}
      </h2>

      <p className="text-gray-600 text-sm mb-2">
        {product.description}
      </p>

      <p className="text-lg font-bold mb-4">
        {product.price} €
      </p>

      <div className="flex items-center gap-3 mb-4">
        <button
          onClick={() => setQuantity(Math.max(1, quantity - 1))}
          className="w-8 h-8 border rounded"
        >
          −
        </button>

        <span>{quantity}</span>

        <button
          onClick={() => setQuantity(quantity + 1)}
          className="w-8 h-8 border rounded"
        >
          +
        </button>
      </div>

      <button
        onClick={handleAddToCart}
        className="btn-primary w-full"
      >
        Ajouter au panier
      </button>
    </div>
  );
};

export default EventProductCard;